/**
 * Single source of truth for languages: enum (codes), display names, and list with flags.
 * Used by LanguageDropdown, reducers, and saga to avoid duplication.
 */

import enFlag from "./flags/us.jpg";
import frFlag from "./flags/french.jpg";
import germanyFlag from "./flags/germany.jpg";
import italyFlag from "./flags/italy.jpg";
import spainFlag from "./flags/spain.jpg";
import russiaFlag from "./flags/russia.jpg";

export enum LanguageCode {
  English = "en",
  French = "fr",
  German = "de",
  Italian = "it",
  Spanish = "es",
  Russian = "ru",
}

export const LANGUAGE_NAMES: Record<LanguageCode, string> = {
  [LanguageCode.English]: "English",
  [LanguageCode.French]: "French",
  [LanguageCode.German]: "German",
  [LanguageCode.Italian]: "Italian",
  [LanguageCode.Spanish]: "Spanish",
  [LanguageCode.Russian]: "Russian",
};

export interface LanguageItem {
  code: LanguageCode;
  name: string;
  flag: string;
}

/** Ordered list of all languages with flags. */
export const LANGUAGES: LanguageItem[] = [
  { code: LanguageCode.English, name: LANGUAGE_NAMES[LanguageCode.English], flag: enFlag },
  { code: LanguageCode.French, name: LANGUAGE_NAMES[LanguageCode.French], flag: frFlag },
  { code: LanguageCode.German, name: LANGUAGE_NAMES[LanguageCode.German], flag: germanyFlag },
  { code: LanguageCode.Italian, name: LANGUAGE_NAMES[LanguageCode.Italian], flag: italyFlag },
  { code: LanguageCode.Spanish, name: LANGUAGE_NAMES[LanguageCode.Spanish], flag: spainFlag },
  { code: LanguageCode.Russian, name: LANGUAGE_NAMES[LanguageCode.Russian], flag: russiaFlag },
];

const languageByCode = new Map<string, LanguageItem>(
  LANGUAGES.map((l) => [l.code, l])
);

export function getLanguageByCode(code: string): LanguageItem | undefined {
  return languageByCode.get(code);
}

export const DEFAULT_LANGUAGE_CODE: LanguageCode = LanguageCode.French;
